import { get } from '..';

const getTemplateSpreadsheet = (BuildingId?: string) => {
  let url: string = 'button/reports/buttonspreadsheet';

  if (BuildingId) url += `?BuildingId=${BuildingId}`;

  return get(url);
};

export default getTemplateSpreadsheet;
